import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function Spin() {
  return <FontAwesomeIcon icon="spinner" spin={true} color="white" />
}
